import { useState, useEffect } from "react";

export enum TDeviceType {
  MOBILE = "Mobile",
  TABLET = "Tablet",
  DESKTOP = "Desktop",
}

export function useDeviceTypeByWidth(): TDeviceType {
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const getDeviceType = (): TDeviceType => {
    if (width < 768) {
      return TDeviceType.MOBILE;
    } else if (width <= 1024) {
      return TDeviceType.TABLET;
    } else {
      return TDeviceType.DESKTOP;
    }
  };

  return getDeviceType();
}
